import React, { useEffect, useState } from "react";
import { Text } from "sprint-common-web";

import { GetMovieByIdResponse } from "../../../../../common/api/catalogue-api/movie/GetMovieByIdResponse";
import { MovieVersionDocumentResponse } from "../../../../../common/api/catalogue-api/movie/MovieDocumentResponse";
import { useCatalogueMovieApi } from "../../../../../common/api/catalogue-api/movie/useCatalogueMovieApi";
import { ContentReferenceType } from "../../../../../common/types/ContentReferenceType";
import { useFileRecordDetailsState } from "../../../../file-records/details/hooks/useFileRecordDetailsState";
import { BuzzVersionsList } from "../../../buzz-version/BuzzVersionsList";
import { MediaBuzzVersion, mapToMediaBuzzVersion } from "../../../buzz-version/MediaBuzzVersion";
import { ContentAssociationMovieDetails } from "../../../content/types/ContentAssociationDetails";
import { checkIsInactiveContentSelected } from "../../../content/utils/checkIsInactiveContentSelected";

interface FileRecordMovieVersionInfoProps {
    movieId: string;
    versionIds: string[];
}

export const FileRecordMovieVersionInfo = (props: FileRecordMovieVersionInfoProps): JSX.Element => {
    const { movieId, versionIds } = props;

    const { setIsArchivedContentAssigned } = useFileRecordDetailsState();

    const { getMovieById } = useCatalogueMovieApi();

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const [movieBuzzVersions, setMovieBuzzVersions] = useState<MediaBuzzVersion[]>([]);

    useEffect(() => {
        setIsLoading(true);

        getMovieById(movieId)
            .then((response: GetMovieByIdResponse) => {
                const versions = response.versions
                    .filter((version: MovieVersionDocumentResponse) => versionIds.includes(version.id))
                    .map(mapToMediaBuzzVersion);

                const isArchivedContentAssigned = checkIsInactiveContentSelected(
                    mapToContentAssociationDetails(response),
                    {
                        versionIds
                    }
                );

                setIsArchivedContentAssigned(isArchivedContentAssigned);

                setMovieBuzzVersions(versions);
            })
            .finally(() => setIsLoading(false));
    }, [movieId, versionIds]);

    if (!versionIds.length) {
        return <Text value="-" />;
    }

    return <BuzzVersionsList versions={movieBuzzVersions} isLoading={isLoading} />;
};

const mapToContentAssociationDetails = (response: GetMovieByIdResponse): ContentAssociationMovieDetails => {
    return {
        id: response.id,
        title: response.title,
        type: ContentReferenceType.Movie,
        source: response.source,
        buzz: response.buzz,
        subtype: response.subtype,
        versions: response.versions
    };
};
